import moment from 'moment';
import numeral from 'numeral';
import { createElement } from 'react';

import {
  FORMAT_DATE,
  FORMAT_DATETIME,
  FORMAT_NUMBER,
} from 'settings';

const UTC_DATETIME_WITHOUT_ZONE_REGEX = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;

function normalizeUtcValue(value) {
  if (typeof value !== 'string') return value;
  return UTC_DATETIME_WITHOUT_ZONE_REGEX.test(value) ? `${value}Z` : value;
}

function dateTimeFormat(value, format = FORMAT_DATETIME, toLocal = false) {
  let formated = '';
  const normalizedValue = normalizeUtcValue(value);
  const parsedValue = moment.utc(normalizedValue);

  if (value && parsedValue.isValid()) {
    const from = toLocal
      ? parsedValue.local()
      : parsedValue;
    formated = from.format(format);
  }
  return formated;
}

function dateFormat(value, format = FORMAT_DATE, toLocal = false) {
  return dateTimeFormat(value, format, toLocal);
}

function numberFormat(value = 0, prefix = null, format = FORMAT_NUMBER) {
  return numeral(value)
    .format(`${prefix ? prefix : ''}${format}`);
}

function linkFormat(value) {
  return createElement('a', {
    href: value,
    target: '_blank',
    rel: 'noopener noreferrer',
    children: 'Ver enlace',
  });
}

export const normalizeListName = (name) => {
  return name
    ?.toLowerCase()
    .replace(/\s+/g, '_');
};

export const formatListNameForDisplay = (name) => {
  if (!name) return '';

  return name
    .split('_')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

export const formatMaskedPan = (maskedPan) => String(maskedPan ?? '')
  .replace(/\s/g, '')
  .replace(/(.{4})(?=.)/g, '$1 ');

export const formatAddress = (address) => {
  try {
    if (!address) return 'No especificada';

    let addressData;
    if (typeof address === 'string') {
      addressData = JSON.parse(address);
    } else {
      addressData = address;
    }

    const parts = [];

    const streetPart = [];
    if (addressData.street) streetPart.push(addressData.street);
    if (addressData.num_ext) streetPart.push(addressData.num_ext);
    if (addressData.num_int) streetPart.push(`Int. ${addressData.num_int}`);

    if (streetPart.length > 0) {
      parts.push(streetPart.join(' '));
    }

    if (addressData.colony) {
      parts.push(addressData.colony);
    }

    if (addressData.mnpio) {
      parts.push(addressData.mnpio);
    }

    if (addressData.state || addressData.administrative_area_code) {
      const estado = addressData.state || addressData.administrative_area_code;
      parts.push(estado);
    }

    if (addressData.postal_code) {
      parts.push(`C.P. ${addressData.postal_code}`);
    }

    if (addressData.reference) {
      parts.push(`Referencia: ${addressData.reference}`);
    }

    if (addressData.country_code) {
      parts.push(addressData.country_code === 'MX' ? 'México' : addressData.country_code);
    }

    return parts.join(', ');

  } catch (error) {
    console.error('Error parsing address:', error);
    return address || 'No especificada';
  }
};

export function formatFilters(filters) {
  const result = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (key.includes('.')) {
      const keys = key.split('.');
      let current = result;

      keys.forEach((k, index) => {
        if (index === keys.length - 1) {
          current[k] = value;
        } else {
          if (!current[k]) {
            current[k] = {};
          }
          current = current[k];
        }
      });
    } else {
      result[key] = value;
    }
  });

  return result;
}

export {
  dateFormat,
  dateTimeFormat,
  numberFormat,
  linkFormat,
};
